import { Component, OnInit, Input, Renderer2 } from '@angular/core';
import { FeesService } from '../../../fees/services/fees.service';
import { ComponentBase } from '../../../../../base-classes/componet-base';
import { FeeSummary } from '../../../fees/models/fee-summary';
import { PrifactRoute } from 'src/app/models/prifact-route';
import { RoutingService } from 'src/app/services/routing-service/routing.service';

@Component({
  selector: 'app-fee-summary',
  templateUrl: './fee-summary.component.html',
  styleUrls: ['./fee-summary.component.scss']
})
export class FeeSummaryComponent extends ComponentBase implements OnInit {

  @Input() feeSummary: FeeSummary

  constructor(private feesService: FeesService
    , private renderer: Renderer2,
    private routingService: RoutingService) {
    super();
  }

  ngOnInit() {
  }

  feeDetailsClicked() {
    let route = new PrifactRoute();
    route.primary_command = ['pages', 'fees'];
    route.append_current_url_to_history = true;
    this.renderer.addClass(document.body, 'second-page');
    this.routingService.navigate(route);
  }
}
